module.exports = __webpack_public_path__ + "static/img/Frame 1010104364@2x (1).ce5fa87.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/Frame 1010104364@2x (1).png
// module id = CkBy
// module chunks = 1